import BaseConstants from "../constants/BaseConstants";
import AppUtils from "./AppUtils";
class LoginAPI{
    login(user){
        const url=BaseConstants.AUTH_URL;
        // user = AppUtils.generateTestUser(user.username, user.password);
        // const option = {
        //     token:"TokenVal",
        //     action:"",
        //     hashData:{
        //         User: user.username,
        //         Password: user.password,
        //         IV: user.IV,
        //         SALT: user.SALT
        //     }
        // };
        return fetch(url, {
            method: 'GET',
            headers: AppUtils.getAuthHeaders(),
            // body:JSON.stringify(option)
        }).catch(error =>{
            return error;
        });
    }

}

export default new LoginAPI();